<template>
  <main id="container" class="page-container">
    <div class="page-header">
      <div class="container">
        <div class="display-flex is-between">
          <page-header title="메인" />
        </div>
      </div>
    </div>
    <div class="page-content event-check relation-eventPage event-bg">
      <div class="container">
        <div class="event-check-container">
          <div class="event-header">
            <h3>연계 이벤트</h3>
            <span class="event-total"
              >전체 <b>{{ totalCount }}건</b></span
            >
          </div>

          <ul class="list-content">
            <li
              v-for="(item, index) in eventList"
              :key="item.orgName"
              :class="['list', `list-${item.color}`]"
            >
              <div class="event-lt">
                <div class="list-order">
                  {{ String(index + 1).padStart(2, "0") }}
                </div>

                <div class="event-info">
                  <p class="org-name">{{ item.orgName }}</p>
                  <p class="event-title">{{ item.title }}</p>
                  <p class="event-content">
                    {{ item.content }}
                  </p>
                </div>
              </div>

              <button type="button" @click="clickLink(item.link)">
                이벤트 바로가기
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import PageHeader from "@/components/content/PageHeader";
import EventTermsModal from "@/components/content/EventTermsModal";
import { mapGetters } from "vuex";

export default {
  name: "EventLinkedPage",
  components: { PageHeader, EventTermsModal },
  data: () => ({
    totalCount: 5,
    eventList: [
      {
        color: "purple",
        orgName: "기관명 입력",
        title: "지역사랑상품권 할인 혜택",
        content:
          "지역 경제 활성화를 위한 지역사랑상품권 할인 혜택을 만나보세요.",
        link: "/ko",
      },
      {
        color: "green",
        orgName: "기관명 입력",
        title: "디지털온누리상품권 이벤트",
        content:
          "더 큰 혜택으로 만나는 디지털온누리상품권 특별 이벤트에 참여해보세요.",
        link: "/ko",
      },
      {
        color: "red",
        orgName: "기관명 입력",
        title: "카드사와 함께하는 쇼핑 혜택",
        content: "주요 카드사와 함께하는 다양한 쇼핑 혜택을 확인해보세요.",
        link: "/ko",
      },
      {
        color: "blue",
        orgName: "기관명 입력",
        title: "배달앱 특별 할인전",
        content: "일상 속 더 큰 혜택, 배달앱 특별 할인전을 만나보세요.",
        link: "/ko",
      },
      {
        color: "yellow",
        orgName: "기관명 입력",
        title: "고향사랑기부제 답례품 만나기",
        content: "고향을 응원하는 마음, 고향사랑기부제 답례품을 확인해보세요.",
        link: "/ko",
      },
    ],
  }),

  computed: {
    ...mapGetters("common", ["isMobile", "commonCode", "campn"]),
    ...mapGetters("auth", ["session", "isAuth"]),
  },
  watch: {},
  async created() {},
  mounted() {},
  methods: {
    clickLink(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
